import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=bc71d3b2&scoped=true"
import script from "./PreviewModal.vue?vue&type=script&lang=js"
export * from "./PreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewModal.vue?vue&type=style&index=0&id=bc71d3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc71d3b2",
  null
  
)

export default component.exports